export default __webpack_public_path__ + "static/media/oh-du-goldigs-suenneli.6086553e.png";